const Datastore = require('./BaseDatastore');

class BaseUsersDatastore extends Datastore {

}

const UsersDatastore = new BaseUsersDatastore();
module.exports = UsersDatastore;